
const initialState = {
    historial: null,
}

const historialPacienteReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_HISTORIAL':
            return {
                ...state,
                historial: action.payload
            }
        default:
            return state
    }
}

export default historialPacienteReducer;